<script setup>
import apiClient from '@/apiClient.js'
import { defineProps, onMounted, onUnmounted, ref } from 'vue'
import dayjs from 'dayjs'

const props = defineProps({
  reference_id: { type: Number, required: true },
})

const histories = ref([])
let refreshTimer

const initialsFor = name => {
  const parts = (name || '').trim().split(' ').filter(Boolean)
  if (!parts.length) {
    return '?'
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase()
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

const getHistories = () => {
  apiClient
    .get('/api/history/' + props.reference_id)
    .then(r => {
      histories.value = r.data
    })
    .catch(() => { /* handle errors if needed */ })
}

// Load on mount
onMounted(() => {
  getHistories()
  refreshTimer = setInterval(getHistories, 15000)
})

onUnmounted(() => {
  if (refreshTimer) {
    clearInterval(refreshTimer)
  }
})

// Expose refresh to parent
defineExpose({
  refresh: getHistories
})
</script>

<template>
  <form-box header="History">
    <div class="max-h-96 overflow-y-auto">
      <div v-for="history in histories" :key="history.id" class="py-2 mb-4">
        <div class="flex gap-4">
          <div class="flex gap-2 items-center">
            <div
              class="flex items-center text-xs justify-center w-8 h-8 rounded-full bg-indigo-500 text-white font-bold overflow-hidden">
              <img v-if="history?.user?.avatar_url" :src="history.user.avatar_url" alt=""
                class="h-full w-full object-cover object-center" />
              <span v-else>{{ initialsFor(history?.user?.name) }}</span>
            </div>
            <div>{{ history?.user?.name ?? 'Neptune System' }}</div>
          </div>
          <div class="text-gray-400">
            <TimeAgo :data="history.created_at" />
          </div>
        </div>
        <div>{{ history.content }}</div>
      </div>
    </div>
  </form-box>
</template>
